import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { guardianAlertService } from "../../../../services/guardianAlertService.js";

import {
    ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalDescription,
  ModalTextarea,
  ModalFooter,
  ModalButtonCancel,
  ModalButtonConfirm,
   RejectButton,
  RejectButtonContainer,
} from './styles';

export const RejectModal = ({ open, onClose, onConfirm, reason, setReason, rejecting }) => {
  if (!open) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Título do modal</ModalHeader>
        <ModalBody>
          <ModalDescription>
            Descreva o motivo da rejeição para que o responsável possa corrigir.
          </ModalDescription>
          <ModalTextarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Ex: Coordenadas não correspondem ao local descrito..."
            rows={4}
          />
        </ModalBody>
        <ModalFooter>
          <ModalButtonCancel onClick={onClose}>
            Cancelar
          </ModalButtonCancel>
          <ModalButtonConfirm
            onClick={onConfirm}
            disabled={!reason.trim() || rejecting}
          >
            {rejecting ? "Rejeitando..." : "Confirmar rejeição"}
          </ModalButtonConfirm>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

